import * as React from 'react';
import './index.scss';
import { ReactComponent as LockSvg } from './images/lock.svg';
import { PlusOutlined, UserSwitchOutlined, StarTwoTone, CloseOutlined } from '@ant-design/icons';
import { Button, Divider, Input, Select, Space, Dropdown, message, Popconfirm } from 'antd';
import { cloneDeep } from 'lodash';
import { addCasualUser, deleteCasualUser, getCasualUsers } from '../../model/api';
export default class UserCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userList: [],// 主账号下的所有账号（主账号+临时账号）
      curUser: props.data,
      inputName: null, // 输入的临时账号姓名
      ownerData:  JSON.parse(localStorage.getItem('user') || '{}')
    }
  }

  componentDidMount() {
    if (!this.props.isMeeting) {
      this.getUserList()
    }
  }

  // 获取当前主账号下的所有账号，包括临时账号
  getUserList = async () => {
    try {
      const { ownerData } = this.state
      const res = await getCasualUsers({ master_id: ownerData.id })
      if (res.code === 200 || res.code === 0) {
        const obj = {
          id: ownerData.id,
          name: ownerData.name,
          avatar: ownerData.avatar,
          isOwner: true
        }
        if (res?.data?.casuals) {
          this.setState({ userList: [obj, ...res.data.casuals] })
        } else {
          this.setState({ userList: [obj] })
        }
      }
    } catch (err) {
      console.log("err=", err)
    }
  }

  // 切换账号
  changeUser = (item) => {
    this.setState({ curUser: item }, () => {
      // const item = this.state.userList.find(i => i.id === value)
      this.props.toChangeUser(item)
    })
  }

  // 添加临时账号
  addUser = async () => {
    try {
      const { userList, inputName, ownerData } = this.state
      if (!inputName) return
      // 新增账号提交
      const res = await addCasualUser({ master_id: ownerData.id, name: inputName.trim() })
      if (res.code === 200 || res.code === 0) {
        const data = cloneDeep(userList)
        data.push(res.data)
        this.setState({ userList: data, inputName: null })
      }
    } catch (err) {
      console.log("err=", err)
    }
  }

  deleteUser = async (item) => {
    try {
      const { userList, curUser, ownerData } = this.state
      const res = await deleteCasualUser({ master_id: ownerData.id, name: item.name })
      // const res = {
      //   code: 200,
      //   data: null
      // }
      if (res.code === 200 || res.code === 0) {
        let data = cloneDeep(userList)
        data = data.filter(i => i.id !== item.id)
        this.setState({ userList: data })
        message.success('临时账号已删除')
        // 删除的是当前选中用户
        console.log('item.id === curUser.id', item.id, curUser.id, userList.find(i => i.isOwner)?.id)
        if (item.id === curUser.id) {
          this.changeUser(userList.find(i => i.isOwner))
        }
      }
    } catch (err) {
      console.log("err=", err)
    }
  }

  render() {
    // const { data, isCasual, tip, onClick } = this.props;
    const { userList, curUser, inputName } = this.state
    return (
      <div className='uc'>
        <div className='uc-show'>
          <div className='uc-left'>
            <img className='uc-avatar' src={curUser?.avatar || "https://originalstatic.aminer.cn/misc/ncov/homepage/avatars/default.jpg"} />
          </div>
          <div className='uc-right'>
          <div className='uc-name'>{(curUser.nickname ? (`${curUser.nickname} - ${curUser.name}`) : curUser.name)}</div>
            {/* <div className='uc-name'>{(data.nickname ? (`${data.nickname} - ${data.name}`) : data.name) + (isCasual ? " (临时用户)" : "")}{data.is_encrypted && <LockSvg className='user-icon' />}</div> */}
            {/* <div className='uc-info'>{data.department}</div> */}
            {/* <div className='uc-info'>{data.position}</div> */}
          </div>
          {/* { tip && <div className='uc-tip'>{tip}</div> } */}
        </div>
        {!this.props.isMeeting && <div className='uc-switch'>
          <Dropdown
            trigger={['click']}
            autoFocus={true}
            menu={{
              items: userList.map(item => {
                return {
                  key: item.id,
                  label: (
                    <div style={{ background: item.id === curUser.id ? '#e6f4ff' : '' }} className='switch-user-item'>
                      {!!item.isOwner && <div onClick={() => this.changeUser(item)}><StarTwoTone style={{ marginRight: 8, color: '#1677ff' }} />{item.name}</div>}
                      {!item.isOwner && <div className='switch-user-item-casual' onClick={() => this.changeUser(item)}>
                        <span>{item.name}</span>
                        <Popconfirm
                          title={`确认要删除临时账号"${item.name}"吗？`}
                          description=""
                          onConfirm={(e) => { e.stopPropagation(); this.deleteUser(item) }}
                          onCancel={(e) => e.stopPropagation()}
                          okText="确认"
                          cancelText="取消"
                        >
                          <CloseOutlined className='casual-delete' onClick={(e) => e.stopPropagation()} />
                        </Popconfirm>
                      </div>}
                    </div>
                  )
                }
              })
            }}
            dropdownRender={menu => (
              <div className="switch-user-dropdown-content">
                {menu}
                <Divider style={{ margin: '8px 0' }} />
                <Space style={{ padding: '0 8px 8px' }}>
                  <Input
                    placeholder="添加临时账号姓名"
                    // ref={inputRef}
                    style={{ width: 150 }}
                    value={inputName}
                    onChange={(e) => this.setState({ inputName: e.target.value })}
                    onKeyDown={(e) => e.stopPropagation()}
                  />
                  <Button
                    type="text"
                    icon={<img className='switch-user-submit-icon' src={require('./images/submit.png')} />}
                    onClick={this.addUser}>
                  </Button>
                </Space>
              </div>
            )}
          >
            <UserSwitchOutlined className='uc-switch-icon' />
          </Dropdown>
          {/* <Select
            style={{ width: 20 }}
            bordered={false}
            placeholder="切换账号"
            dropdownMatchSelectWidth={false}
            suffixIcon={<UserSwitchOutlined />}
            value={curUserId}
            onChange={this.changeUser}
            dropdownRender={(menu) => (
              <div className='user-dropdown'>
                {menu}
                <Divider style={{ margin: '8px 0' }} />
                <Space style={{ padding: '0 8px 4px' }}>
                  <Input
                    placeholder="输入临时账号姓名"
                    // ref={inputRef}
                    value={inputName}
                    onChange={(e) => this.setState({ inputName: e.target.value })}
                    onKeyDown={(e) => e.stopPropagation()}
                  />
                  <Button type="text" icon={<PlusOutlined />} onClick={this.addUser}></Button>
                </Space>
              </div>
            )}
            options={userList.map((item) => ({ label: item.name, value: item.id }))}
          /> */}
        </div>}
      </div>
    )
  }
}